import { useEffect, useState } from "react";
import styles from "./SourceSheet.module.css";
import { Button } from "./Button";
import { quizApi, type SourceResponse } from "../api/quiz";

export function SourceSheet({ fragmentId, onClose }: { fragmentId: string; onClose: () => void }) {
  const [data, setData] = useState<SourceResponse | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    quizApi
      .source(fragmentId)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [fragmentId]);

  const pageLabel = data
    ? data.fragment.pageStart === data.fragment.pageEnd
      ? `${data.fragment.pageStart}`
      : `${data.fragment.pageStart}–${data.fragment.pageEnd}`
    : "";

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Источник">
        <div className={styles.handle} />
        <div className={styles.eyebrow}>Источник</div>

        {error && <p>Не удалось загрузить источник. Попробуйте ещё раз.</p>}
        {!error && !data && <p>Загрузка…</p>}

        {data && (
          <>
            <dl className={styles.metaList}>
              <div className={styles.metaRow}>
                <dt>Книга</dt>
                <dd>{data.book?.title ?? "—"}</dd>
              </div>
              {(data.fragment.authors ?? data.book?.author) && (
                <div className={styles.metaRow}>
                  <dt>Авторы</dt>
                  <dd>{data.fragment.authors ?? data.book?.author}</dd>
                </div>
              )}
              <div className={styles.metaRow}>
                <dt>Статья / раздел</dt>
                <dd>
                  {data.fragment.chapter}
                  {data.fragment.section ? ` · ${data.fragment.section}` : ""}
                </dd>
              </div>
              <div className={styles.metaRow}>
                <dt>Страница</dt>
                <dd>{pageLabel}</dd>
              </div>
            </dl>

            <div className={styles.fragmentEyebrow}>Фрагмент источника</div>
            <div className={styles.fragment}>{data.fragment.text}</div>
          </>
        )}

        <div className={styles.closeRow}>
          <Button variant="ghost" onClick={onClose}>
            Закрыть
          </Button>
        </div>
      </div>
    </div>
  );
}
